import {
  useEffect,
  useContext,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import $ from "jquery";
import DataTable from "datatables.net";
import { LoginContext } from "../../hooks/context/LoginContext";
import axios from "axios";
import { Modal } from "react-bootstrap";
import Menusup from "../../componentes/menus/menusup/Menusup";
import Sidebar from "../../componentes/menus/sidebar/Sidebar";
import Footer from "../../componentes/footer/Footer";
import Section from "../../componentes/ui/Section";
import MiDataTableServer from "../../componentes/ui/MiDataTableServer";
import useServerPagination from "../../hooks/useServerPagination";
import PermissionRefused from "../../componentes/ui/PermissionRefused";
import LoadingPage from "../../componentes/ui/LoadingPage";
import Button from "../../componentes/ui/Button";
import MiSelect from "../../componentes/formulario/MiSelect";
import FormInput from "../../componentes/formulario/FormInput";
import CheckIos from "../../componentes/ui/CheckIos";
import UplmPlusBtn from "../../componentes/formulario/UpmlPlusBtn/UplmPlusBtn";
import TextArea from "../../componentes/formulario/TextArea";
import { Spinner } from "react-bootstrap";
import { Accordion, Card } from "react-bootstrap";
import { alertService } from "../../services/alertservice";
import { Alert } from "../../componentes/ui/Alert";
import useLogicForm from "../../hooks/useLogicForm";
import Cookies from "universal-cookie";

import {
  getApiUrl,
  axiosPost,
  getAhorayyyymmdd,
  getTitle,
  getDecodedCookie,
  getNumFromDataTraPdtAsignar,
  getNumNoLeidosExcedidos,
  getNumNoLeidosEnPlazo,
} from "../../helpers/helperApp";

import { Fragment } from "react";
import FormRow from "../../componentes/formulario/FormRow";

$.DataTable = DataTable;
const url = window.location;

function Manlogv2V2(props) {
  const cookies = new Cookies();
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();

  // ***** Context *****
  const {
    validateSesion,
    socket,
    confApp,
    saveConfApp,
    getConfApp,
    apiKey,
    appCryptCom,
  } = useContext(LoginContext);

  // ***** State para la configuración de la pantalla *****
  const [confPantalla, saveConfPantalla] = useState(confApp);
  const [columnas, setColumnasLineas] = useState([]);
  const [loadedConf, saveLoadedConf] = useState(false);
  const [tieneNivel, saveTieneNivel] = useState(true);
  const [acordeonPrin, saveAcordeonPrin] = useState(null);
  const [loading, saveLoading] = useState(false);
  const [selectIdEquipo, saveSelectIdEquipo] = useState(0);
  const [inputDescripcion, saveInputDescripcion] = useState("");
  const [controlMantenimientos, saveControlMantenimientos] = useState([]);
  const [showModal, saveShowModal] = useState(false);
  const [accionModal, saveAccionModal] = useState("");
  const [backUpOptionsSelectEquipo, saveBackUpOptionsSelectEquipo] = useState(
    [],
  );
  const [selectIdEquipoModal, saveSelectIdEquipoModal] = useState(0);
  const [inputModalFecPro, saveInputModalFecPro] = useState("");
  const [inputModalFecUlt, saveInputModalFecUlt] = useState(
    getAhorayyyymmdd() + "T00:00",
  );
  const [checkModalAvisar, saveCheckModalAvisar] = useState(true);
  const [inputModalHoras, saveInputModalHoras] = useState("");
  const [inputModalHActuales, saveInputModalHActuales] = useState("");
  const [recurrencia, saveRecurrencia] = useState("");
  const [tipoRecurrenciaDocModal, saveTipoRecurrenciaDocModal] = useState(0);
  const [lineaEditar, saveLineaEditar] = useState(null);
  const [equipoAsociadoMant, saveEquipoAsociadoMant] = useState(0);
  const [adjuntos, saveAdjuntos] = useState([]);
  const [txtHeaderModal, saveTxtHeaderModal] = useState("");
  const [loadingFecPro, saveLoadingFecPro] = useState(false);
  const [showModalMensaje, saveShowModalMensaje] = useState(false);
  const [mensajeId, saveMensajeId] = useState(0);
  const [mensajeEstado, saveMensajeEstado] = useState(0);
  const [mensajeDe, saveMensajeDe] = useState(0);
  const [mensajePara, saveMensajePara] = useState(0);
  const [mensajeEnvio, saveMensajeEnvio] = useState("");
  const [mensajeRecordatorio, saveMensajeRecordatorio] = useState("");
  const [mensajeLimite, saveMensajeLimite] = useState("");
  const [mensajeLectura, saveMensajeLectura] = useState("");
  const [mensajeMsg, saveMensajeMsg] = useState("");
  const [totLin, saveTotLin] = useState(0);
  const [estDoc, saveEstDoc] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageAsignar, setCurrentPageAsignar] = useState(1);
  const [currentPagePendientes, setCurrentPagePendientes] = useState(1);
  const [filhis, setFilhis] = useState(false);
  const [sortColumnHistoricos, setSortColumnHistoricos] = useState("");
  const [sortDirectionHistoricos, setSortDirectionHistoricos] = useState("asc");
  const [sortColumnAsignar, setSortColumnAsignar] = useState("");
  const [sortDirectionAsignar, setSortDirectionAsignar] = useState("asc");
  const [sortColumnPendientes, setSortColumnPendientes] = useState("");
  const [sortDirectionPendientes, setSortDirectionPendientes] = useState("asc");
  const [pendientesMantenimientos, savePendientesMantenimientos] = useState({
    data: [],
  });

  // ***** Custom Hook - Lógica de los formularios *****
  const { loadReg, saveLoadReg, saveLoadingTable } = useLogicForm();

  const apiKeyRef = useRef(apiKey);
  const saveLoadingTableRef = useRef(saveLoadingTable);
  apiKeyRef.current = apiKey;
  saveLoadingTableRef.current = saveLoadingTable;

  const paginationOptions = useMemo(
    () => ({
      apiEndpoint: "/Manlogv2/getHistoricos",
      apiKey: apiKeyRef.current,
      setLoadingTableExternal: saveLoadingTableRef.current,
      requiredParams: [],
      sortColumn: sortColumnHistoricos,
      sortDirection: sortDirectionHistoricos,
    }),
    [sortColumnHistoricos, sortDirectionHistoricos],
  );

  const paginationPendingOptions = useMemo(
    () => ({
      apiEndpoint: "/Manlogv2/getPendientesDeAsignar",
      apiKey: apiKeyRef.current,
      setLoadingTableExternal: saveLoadingTableRef.current,
      requiredParams: [],
      sortColumn: sortColumnAsignar,
      sortDirection: sortDirectionAsignar,
    }),
    [sortColumnAsignar, sortDirectionAsignar],
  );

  const paginationPendingMaintenanceOptions = useMemo(
    () => ({
      apiEndpoint: "/Manlogv2/getMantenimientosPendientes",
      apiKey: apiKeyRef.current,
      setLoadingTableExternal: saveLoadingTableRef.current,
      additionalParams: { filhis: filhis },
      requiredParams: [],
      perPage: 5,
      sortColumn: sortColumnPendientes,
      sortDirection: sortDirectionPendientes,
    }),
    [filhis, sortColumnPendientes, sortDirectionPendientes],
  );

  // ***** Hook de paginación server-side *****
  const {
    data: historicos,
    loadingTable,
    totalPages,
    paginationInfo,
    handlePageChange,
    handleNextPage,
    handlePreviousPage,
    getPaginationItems,
    handleDataTableSearch,
    handlePageLengthChange,
    handleSortChange: handleSortChangeHistoricos,
    reload: reloadHistoricos,
  } = useServerPagination({
    ...paginationOptions,
    currentPage,
    setCurrentPage,
  });

  const {
    data: pendientesAsignar,
    loadingTable: loadingTableAsignar,
    totalPages: totalPagesAsignar,
    paginationInfo: paginationInfoAsignar,
    handlePageChange: handlePageChangeAsignar,
    handleNextPage: handleNextPageAsignar,
    handlePreviousPage: handlePreviousPageAsignar,
    getPaginationItems: getPaginationItemsAsignar,
    handleDataTableSearch: handleDataTableSearchAsignar,
    handlePageLengthChange: handlePageLengthChangeAsignar,
    handleSortChange: handleSortChangeAsignar,
    reload: reloadPendientesAsignar,
  } = useServerPagination({
    ...paginationPendingOptions,
    currentPage: currentPageAsignar,
    setCurrentPage: setCurrentPageAsignar,
  });

  const {
    data: mantenimientosPendientes,
    loadingTable: loadingTableMantenimientos,
    totalPages: totalPagesMantenimientos,
    paginationInfo: paginationInfoMantenimientos,
    handlePageChange: handlePageChangeMantenimientos,
    handleNextPage: handleNextPageMantenimientos,
    handlePreviousPage: handlePreviousPageMantenimientos,
    getPaginationItems: getPaginationItemsMantenimientos,
    handleDataTableSearch: handleDataTableSearchMantenimientos,
    handlePageLengthChange: handlePageLengthChangeMantenimientos,
    handleSortChange: handleSortChangePendientes,
    reload: reloadMantenimientos,
  } = useServerPagination({
    ...paginationPendingMaintenanceOptions,
    currentPage: currentPagePendientes,
    setCurrentPage: setCurrentPagePendientes,
  });

  const onSortChangeHistoricos = useCallback((column, direction) => {
    setSortColumnHistoricos(column);
    setSortDirectionHistoricos(direction);
  }, []);

  const onSortChangeAsignar = useCallback((column, direction) => {
    setSortColumnAsignar(column);
    setSortDirectionAsignar(direction);
  }, []);

  const onSortChangePendientes = useCallback((column, direction) => {
    setSortColumnPendientes(column);
    setSortDirectionPendientes(direction);
  }, []);

  useEffect(() => {
    savePendientesMantenimientos({ data: mantenimientosPendientes });
  }, [mantenimientosPendientes]);

  const init = async () => {
    handleMantenimientosPendientesFilter();
    await Promise.all([reloadPendientesAsignar(), reloadHistoricos()]);
  };

  useEffect(() => {
    validateSesion(props)
      .then((respuesta) => {
        // Si la configuración aún no ha cargado, la pedimos
        if (confPantalla === undefined) {
          return getConfApp();
        }

        document.title = getTitle(
          confPantalla.config.trad,
          confPantalla.manlogv2.title,
        );

        if (respuesta == 1) {
          saveTieneNivel(true);
          init();
        } else if (respuesta == 0) {
          saveTieneNivel(false);
        }

        saveLoadedConf(true);
      })
      .then((respuesta) => {
        if (respuesta !== undefined) {
          saveConfPantalla(respuesta.msg);
          saveConfApp(respuesta.msg);
        }
      })
      .catch((error) => {
        // Evita que un fallo silencioso deje el spinner colgado
        console.error("Error en inicialización de Manlogv2V2:", error);
        saveLoadedConf(true);
      });

    return () => {
      if (socket != null) {
        socket.emit("salirPantalla", {
          idusu: getDecodedCookie("id"),
          tabla: "undefined",
        });
      }
      document.querySelector("body").classList.remove("sidebar-open");
      source.cancel();
    };
  }, [confPantalla]);

  const handleMantenimientosPendientesFilter = async (btnDataTable = false) => {
    if (btnDataTable == true) {
      let btn = document.getElementsByClassName("filterBtnManlogV2");
      if (btn && btn[0] && btn[0].classList.contains("active")) {
        btn[0].classList.remove("active");
        setFilhis(false);
      } else if (btn && btn[0] && btn[0].classList) {
        btn[0].classList.add("active");
        setFilhis(true);
      }
    } else {
      let btn = document.getElementsByClassName("filterBtnManlogV2");
      if (btn && btn[0] && btn[0].classList.contains("active")) {
        setFilhis(true);
      } else {
        setFilhis(false);
      }
    }
    // The useMemo will trigger a reload when filhis changes
    setCurrentPagePendientes(1);
  };

  const createNew = () => {
    saveAccionModal("crear");
    saveShowModal(true);
    saveInputDescripcion(inputDescripcion);
    saveSelectIdEquipoModal(selectIdEquipo);
    if (selectIdEquipo == 0) {
      saveTipoRecurrenciaDocModal(0);
      saveRecurrencia("");
    }
    // saveInputModalFecPro("");
    saveInputModalFecUlt(getAhorayyyymmdd() + "T00:00");
    saveInputModalHoras(0);
    saveTxtHeaderModal(inputDescripcion);
    saveCheckModalAvisar(true);
  };

  const accionCrear = async (
    e,
    continueLoading = false,
    clickBtnAceptarEjecutar = false,
  ) => {
    saveLoading(true);

    let idTrabajo = 0;

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("equipomantenimiento", selectIdEquipoModal);
    data.append("descripcion", inputDescripcion);
    data.append("fecpro", inputModalFecPro);
    data.append("fecult", inputModalFecUlt);
    data.append("avisar", checkModalAvisar);
    data.append("horas", inputModalHoras);
    data.append("hactuales", inputModalHActuales);
    data.append("accion", "crear");
    data.append("clickbtnaceptarejecutar", clickBtnAceptarEjecutar);

    // Adjuntos nuevos datos
    const inputsNews = document.querySelectorAll(
      'input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]',
    );
    for (let i = 0; i < inputsNews.length; i++) {
      data.append(inputsNews[i].name, inputsNews[i].value);
    }
    // Adjuntos nuevos ficheros
    for (let i = 0; i < adjuntos.length; i++) {
      if (!adjuntos[i].urlAdd) {
        data.append(adjuntos[i]["id"] + "[]", adjuntos[i]);
      }
    }
    const respuesta = await axios.post(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.controles.createdoc,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (typeof respuesta.data === "string") {
      saveShowModal(false);
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    } else {
      if (respuesta.data[0]) {
        idTrabajo = respuesta.data[0];
      }
      await init();
      if (continueLoading == false) {
        saveShowModal(false);
        saveLoading(false);
      }
      saveSelectIdEquipo(0);
      saveInputDescripcion("");
      saveSelectIdEquipoModal(0);
      saveInputModalFecPro("");
      saveInputModalFecUlt(getAhorayyyymmdd() + "T00:00");
      saveCheckModalAvisar(true);
      saveInputModalHoras(0);
      //Reseteamos los input de los adjuntos
      let adjs = document.querySelectorAll("input[type=file]");
      for (let i = 0; i < adjs.length; i++) {
        adjs[i].value = null;
        adjs[i].files = null;
      }

      //Reseteamos los adjuntos pendientes de subir.
      saveAdjuntos([]);
    }

    reloadPendientesAsignar();

    return idTrabajo;
  };

  const showEditarLinea = (e, rowData) => {
    saveAccionModal("editar");
    saveLineaEditar(rowData);
    saveTxtHeaderModal(rowData.descripcionNoHtml);
    saveSelectIdEquipoModal(rowData.idoriot);
    saveInputModalFecUlt(rowData.fecult + "T00:00");
    saveInputModalFecPro(rowData.fecpro + "T00:00");
    saveInputModalHoras(rowData.horas);
    saveInputModalHActuales(rowData.hactuales);
    saveCheckModalAvisar(true);
    saveTipoRecurrenciaDocModal(rowData["recurrencia.tipo"]);
    saveRecurrencia(rowData.recurrencia);
    saveEquipoAsociadoMant(rowData.idequ);
    saveTotLin(rowData.totlin);
    saveEstDoc(rowData.idest);
    saveShowModal(true);
  };

  const accionEditar = async (
    e,
    continueLoading = false,
    clickBtnAceptarEjecutar = false,
  ) => {
    let idTrabajo = 0;

    if (new Date(inputModalFecUlt) > new Date(inputModalFecPro)) {
      // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlogv2.txterrordates.title}`,
        { autoClose: true },
      );
      return;
    }

    saveLoading(true);

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("equipomantenimiento", selectIdEquipoModal);
    data.append("descripcion", inputDescripcion);
    data.append("fecpro", inputModalFecPro);
    data.append("fecult", inputModalFecUlt);
    data.append("avisar", checkModalAvisar);
    data.append("horas", inputModalHoras);
    data.append("hactuales", inputModalHActuales);
    data.append("accion", "editar");
    data.append("docedicion", JSON.stringify(lineaEditar));
    data.append("clickbtnaceptarejecutar", clickBtnAceptarEjecutar);

    // Adjuntos existentes
    const inputs = document.querySelectorAll(
      'input[name*="fileExistUrl"], input[name*="fileExist"]',
    );
    for (let i = 0; i < inputs.length; i++) {
      data.append(inputs[i].name, inputs[i].value);
    }

    // Adjuntos nuevos datos
    const inputsNews = document.querySelectorAll(
      'input[name*="fileNew**"], textarea[name*="fileNew**"], input[name*="fileNewUrl**"], textarea[name*="fileNewUrl**"]',
    );
    for (let i = 0; i < inputsNews.length; i++) {
      data.append(inputsNews[i].name, inputsNews[i].value);
    }
    // Adjuntos nuevos ficheros
    for (let i = 0; i < adjuntos.length; i++) {
      if (!adjuntos[i].urlAdd) {
        data.append(adjuntos[i]["id"] + "[]", adjuntos[i]);
      }
    }
    const respuesta = await axios.post(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.controles.createdoc,
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (typeof respuesta.data === "string") {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    }
    if (respuesta.data[0]) {
      idTrabajo = respuesta.data[0];
    }

    await init();
    if (continueLoading == false) {
      saveLoading(false);
      saveShowModal(false);
    }
    saveSelectIdEquipo(0);
    saveSelectIdEquipoModal(0);
    saveInputDescripcion("");
    //Reseteamos los input de los adjuntos
    let adjs = document.querySelectorAll("input[type=file]");
    for (let i = 0; i < adjs.length; i++) {
      adjs[i].value = null;
      adjs[i].files = null;
    }

    //Reseteamos los adjuntos pendientes de subir.
    saveAdjuntos([]);

    return idTrabajo;
  };

  const loadMantenimientosPendientes = async (btnDataTable = false) => {
    saveLoading(true);

    const data = new FormData();
    if (btnDataTable == true) {
      let btn = document.getElementsByClassName("filterBtnManlogV2");
      if (btn && btn[0] && btn[0].classList.contains("active")) {
        btn[0].classList.remove("active");
      } else if (btn && btn[0].classList) {
        btn[0].classList.add("active");
      }
    }

    data.append("validacion", apiKey());
    data.append("filhis", true);

    const respuesta = await axiosPost(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.controles.datatablemantenimientospendientes
        .getdata,
      data,
      source.token,
    );

    if (typeof respuesta.data !== "string") {
      savePendientesMantenimientos(respuesta.data);
    } else if (typeof respuesta.data === "string") {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    }

    saveLoading(false);
  };

  const ejecutar = async (e) => {
    if (new Date(inputModalFecUlt) > new Date(inputModalFecPro)) {
      // Error la fecha de próxima ejecución debe ser posterior a la de última ejecución
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${confPantalla.manlogv2.txterrordates.title}`,
        { autoClose: true },
      );
      return;
    }

    let idTrabajo = 0;
    const equipoMantenimiento = selectIdEquipoModal;
    if (accionModal == "editar") {
      idTrabajo = await accionEditar(e, true, true);
    } else {
      idTrabajo = await accionCrear(e, true, true);
    }
    saveLoading(true);

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("idtra", idTrabajo);
    data.append("accion", accionModal);
    data.append("equipomantenimiento", equipoMantenimiento);
    const respuesta = await axiosPost(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.controles.ejecutar,
      data,
      source.token,
    );

    if (typeof respuesta.data === "string") {
      saveShowModal(false);
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    } else {
      // Redirigir al documentostrab
      props.history.push(
        "/documentostrab/" + idTrabajo + "/null/null/manlogv2",
      );
    }

    saveLoading(false);
    saveShowModal(false);
  };

  const open = (e, rowData) => {
    let ruta = rowData.ruta;
    const esUrl =
      ruta.startsWith("http://") ||
      ruta.startsWith("https://") ||
      ruta.startsWith("www.");
    const baseUrl = getApiUrl(window.location.origin);

    try {
      if (ruta.startsWith("www.")) {
        ruta = `https://${ruta}`;
      }

      if (esUrl) {
        // Intentar abrir la URL en una nueva pestaña
        const nuevaVentana = window.open(ruta, "_blank");
        if (!nuevaVentana) {
          alertService.error(
            `<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`,
            { autoClose: true },
          );
        }
      } else {
        // Comprobar si es un archivo local o una ruta relativa
        const archivoUrl = ruta.startsWith("file://")
          ? ruta
          : `${baseUrl}${ruta}`;
        const nuevaVentana = window.open(archivoUrl, "_blank");
        if (!nuevaVentana) {
          alertService.error(
            `<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`,
            { autoClose: true },
          );
        }
      }
    } catch (error) {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i> ${confPantalla.manlogv2.txterroropen.title}`,
        { autoClose: true },
      );
    }
  };

  const handleInputFecUltEje = async (e) => {
    handleInput(e, saveInputModalFecUlt);
    if (selectIdEquipoModal != 0) {
      await recalculateFecProxEje(selectIdEquipoModal, e.target.value);
    }
  };

  const showMensaje = (e, rowData) => {
    saveLineaEditar(rowData);
    // saveSelectIdEquipoModal(rowData.idori);
    saveInputModalFecUlt(rowData.fecult + "T00:00");
    saveInputModalFecPro(rowData.fecpro + "T00:00");
    saveInputModalHoras(rowData.horas);
    saveInputModalHActuales(rowData.hactuales);

    saveMensajeId(rowData.id);
    saveMensajeEstado(rowData.msg_idest);
    saveMensajeDe(rowData.from_idage);
    saveMensajePara(rowData.to_idage);
    saveMensajeEnvio(rowData.send_date + "T00:00");
    saveMensajeRecordatorio(rowData.rem_date + "T00:00");
    saveMensajeLimite(rowData.exp_date + "T00:00");
    saveMensajeLectura(rowData.read_date + "T00:00");
    saveMensajeMsg(rowData.msg_sub);

    saveShowModalMensaje(true);
  };

  const accionMensaje = async (e) => {
    saveLoading(true);

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("id", mensajeId);
    data.append("msg_idest", mensajeEstado);
    data.append("rem_date", mensajeRecordatorio);
    data.append("exp_date", mensajeLimite);
    data.append("to_idage", mensajePara);
    data.append("msg_sub", mensajeMsg);
    const respuesta = await axiosPost(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.modalmensaje.updatemensaje,
      data,
      source.token,
    );

    if (typeof respuesta.data !== "string") {
      alertService.success(
        `<i class="fal fa-check-circle mr-1"></i>${confPantalla.manlogv2.modalmensaje.mensajeactualizado.title}`,
        { autoClose: true },
      );
    } else if (typeof respuesta.data === "string") {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    }

    await handleMantenimientosPendientesFilter();

    saveLoading(false);
    saveShowModalMensaje(false);
  };

  const setAviso = async () => {
    saveLoading(true);

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("equipomantenimiento", selectIdEquipoModal);
    data.append("descripcion", inputDescripcion);
    data.append("fecpro", inputModalFecPro);
    data.append("fecult", inputModalFecUlt);
    data.append("accion", accionModal);
    data.append("docedicion", lineaEditar ? JSON.stringify(lineaEditar) : null);

    const respuesta = await axiosPost(
      getApiUrl(window.location.origin) + "/manlogv2/setaviso",
      data,
      source.token,
    );

    if (typeof respuesta.data !== "string") {
      alertService.success(
        `<i class="fal fa-check-circle mr-1"></i>${confPantalla.manlogv2.modal.txtavisocreado.title}`,
        { autoClose: true },
      );
    } else if (typeof respuesta.data === "string") {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    }

    await handleMantenimientosPendientesFilter();

    saveLoading(false);
    saveShowModal(false);
  };

  const handleSelect = async (
    selectedItem,
    nameOfComponent,
    saveData,
    modal = false,
  ) => {
    if (selectedItem) {
      saveData(selectedItem.value);
      if (nameOfComponent.name == "idequ") {
        // saveTxtHeaderModal(selectedItem.lableNoHtml);
        saveEquipoAsociadoMant(selectedItem.idequ);
        saveInputModalHActuales(selectedItem.hactuales);
        saveTipoRecurrenciaDocModal(selectedItem["recurrencia.tipo"]);
        saveRecurrencia(selectedItem.recurrencia);
        saveTotLin(selectedItem.totlin);
        // saveEstDoc(selectedItem.idest);
        if (modal == false) saveInputDescripcion(selectedItem.lableNoHtml);
        if (selectedItem["recurrencia.tipo"] != 0) {
          await recalculateFecProxEje(selectedItem.value);
        }
      }
    } else {
      saveData(0);
      if (nameOfComponent.name == "idequ") {
        saveTxtHeaderModal("");
        saveEquipoAsociadoMant(0);
        saveInputModalHActuales(0);
        saveInputDescripcion("");
        saveTipoRecurrenciaDocModal(0);
        saveRecurrencia("");
        saveTotLin(0);
        // saveEstDoc(0);
        saveInputModalFecPro("");
      }
    }
  };

  const recalculateFecProxEje = async (idDoc, fecUlt = null) => {
    saveLoadingFecPro(true);

    const data = new FormData();
    data.append("validacion", apiKey());
    data.append("fecult", fecUlt != null ? fecUlt : inputModalFecUlt);
    data.append("equipomantenimiento", idDoc);
    data.append("accion", accionModal);
    const respuesta = await axiosPost(
      getApiUrl(window.location.origin) +
      confPantalla.manlogv2.controles.recalculatefecproxeje,
      data,
      source.token,
    );

    if (typeof respuesta.data === "string") {
      alertService.error(
        `<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`,
        { autoClose: true },
      );
    } else {
      saveInputModalFecPro(respuesta.data[0]);
    }
    saveLoadingFecPro(false);
  };

  const setMantenimientoToForm = async (e, rowData) => {
    saveSelectIdEquipo(rowData.id);
    saveInputDescripcion(rowData.descripcionnohtml);
    saveTipoRecurrenciaDocModal(rowData["recurrencia.tipo"]);
    await recalculateFecProxEje(rowData.id);
  };

  const handleInput = (e, save) => {
    save(e.target.value);
  };

  const handleCheck = (e, save) => {
    if (e.target.checked) {
      save(true);
    } else {
      save(false);
    }
  };

  const toogleAcordeon = (id) => {
    if (acordeonPrin == id) {
      saveAcordeonPrin(null);
    } else {
      saveAcordeonPrin(id);
    }
  };

  const goToEquiposL = (e, rowData) => {
    e.stopPropagation();

    const equipoId = rowData.idequ;
    const path =
      equipoId && equipoId !== "0" && equipoId !== ""
        ? `/equiposl/${equipoId}`
        : "/equiposl";

    window.open(
      `${window.location.origin}${path}`,
      "_blank",
      "noopener,noreferrer",
    );
  };

  return (
    <div className="App wrapper">
      <div>
        {loadReg ? (
          <div className="alertFullWhite">
            <Spinner animation="border" />
          </div>
        ) : null}
      </div>
      {confPantalla !== undefined ? (
        <Fragment>
          <Alert fondo={true} />
          <Menusup props={props} />
          <Sidebar props={props} />
        </Fragment>
      ) : null}
      <div className="content-wrapper">
        <div className="content-header"></div>
        <section className="content">
          {!tieneNivel ? (
            <PermissionRefused
              traduction={confPantalla.config.trad.components.permissionrefused}
            />
          ) : (
            <Fragment>
              {loadedConf === true && confPantalla !== undefined ? (
                <Section
                  tituloenhtml={true}
                  titulo={confPantalla.manlogv2.section.titulo}
                  icono={confPantalla.manlogv2.section.icono}
                  col={confPantalla.manlogv2.section.col}
                  informes={confPantalla.manlogv2.controles.informes}>
                  <FormRow>
                    <MiSelect
                      estadoForm={""}
                      val={selectIdEquipo}
                      loading={loading ? true : false}
                      id={confPantalla.manlogv2.controles.idequ.id}
                      name={confPantalla.manlogv2.controles.idequ.name}
                      label={confPantalla.manlogv2.controles.idequ.label}
                      placeholder={
                        confPantalla.manlogv2.controles.idequ.placeholder
                      }
                      col={confPantalla.manlogv2.controles.idequ.col}
                      isClearable={
                        confPantalla.manlogv2.controles.idequ.isclearable
                      }
                      isSearchable={
                        confPantalla.manlogv2.controles.idequ.issearchable
                      }
                      dataType={confPantalla.manlogv2.controles.idequ.datatype}
                      data={confPantalla.manlogv2.controles.idequ.data}
                      required={confPantalla.manlogv2.controles.idequ.required}
                      disabled={confPantalla.manlogv2.controles.idequ.disabled}
                      readOnly={confPantalla.manlogv2.controles.idequ.readonly}
                      disablethisid={
                        confPantalla.manlogv2.controles.idequ.disablethisid
                      }
                      disableids={
                        confPantalla.manlogv2.controles.idequ.disableids
                      }
                      formulario={{ id: 0 }}
                      change={(selectedItem, nameOfComponent) =>
                        handleSelect(
                          selectedItem,
                          nameOfComponent,
                          saveSelectIdEquipo,
                        )
                      }
                      saveBackUpOptions={saveBackUpOptionsSelectEquipo}
                    />
                    <FormInput
                      clasesInput={" inputRequired "}
                      estadoForm={""}
                      value={inputDescripcion}
                      loading={loading ? true : false}
                      id={confPantalla.manlogv2.controles.descripcion.id}
                      type={confPantalla.manlogv2.controles.descripcion.type}
                      name={confPantalla.manlogv2.controles.descripcion.name}
                      label={confPantalla.manlogv2.controles.descripcion.label}
                      placeholder={
                        confPantalla.manlogv2.controles.descripcion.placeholder
                      }
                      col={confPantalla.manlogv2.controles.descripcion.col}
                      required={
                        confPantalla.manlogv2.controles.descripcion.required
                      }
                      readonly={
                        confPantalla.manlogv2.controles.descripcion.readonly
                      }
                      disabled={
                        confPantalla.manlogv2.controles.descripcion.disabled
                      }
                      change={(e) => handleInput(e, saveInputDescripcion)}
                      onBlur={null}
                      autoCompleteData={backUpOptionsSelectEquipo}
                      saveSuggestion={saveInputDescripcion}
                      keyForSearch={"label"}
                      keyToShow={"lableNoHtml"}
                    />
                  </FormRow>
                  <p className="font-italic text-center">
                    {confPantalla.manlogv2.txtrequired.title}
                  </p>
                  <Button
                    clases={"col-12 mt-2 mb-4"}
                    estadoForm={loading ? "disabled" : ""}
                    color={"success"}
                    type="button"
                    icono={""}
                    id="btnnew"
                    texto={confPantalla.manlogv2.controles.btnnew.title}
                    accion={createNew}
                    disabled={
                      inputDescripcion == "" || loading == true ? true : false
                    }
                  />
                  {loading == true ? (
                    <div
                      style={{
                        height: 50,
                        marginTop: 5,
                        marginBottom: 10,
                        textAlign: "center",
                      }}>
                      <Spinner animation="border" />
                    </div>
                  ) : null}
                  <Accordion defaultActiveKey={""}>
                    <Card>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="1"
                        onClick={() => toogleAcordeon("1")}
                        className={acordeonPrin == "1" ? "activeAcordeon" : ""}>
                        <i
                          className={
                            confPantalla.manlogv2.mantenimientospendientes.icono
                          }></i>
                        {confPantalla.manlogv2.mantenimientospendientes.titulo}
                        <span
                          className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 "
                          style={{ borderRadius: "5px" }}>
                          {getNumNoLeidosExcedidos(pendientesMantenimientos)}
                        </span>
                        <span
                          className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 "
                          style={{ borderRadius: "5px" }}>
                          {getNumNoLeidosEnPlazo(pendientesMantenimientos)}
                        </span>
                        {cookies.get("nivel") <= "3" ? (
                          <Fragment>
                            <span className="mr-1 ml-1"> / </span>
                            {
                              confPantalla.manlogv2.avisosdemantenimientos
                                .titulo
                            }
                            <span
                              className="alert-danger ml-2 pl-3 pr-3 pt-2 pb-2 "
                              style={{ borderRadius: "5px" }}>
                              {getNumFromDataTraPdtAsignar(
                                pendientesAsignar,
                                true,
                                false,
                              )}
                            </span>
                            <span
                              className="alert-success ml-2 pl-3 pr-3 pt-2 pb-2 "
                              style={{ borderRadius: "5px" }}>
                              {getNumFromDataTraPdtAsignar(
                                pendientesAsignar,
                                false,
                                false,
                              )}
                            </span>
                          </Fragment>
                        ) : null}
                        {acordeonPrin == "1" ? (
                          <i
                            className={
                              "fal fa-chevron-up float-right fa-2x"
                            }></i>
                        ) : (
                          <i
                            className={
                              "fal fa-chevron-down float-right fa-2x"
                            }></i>
                        )}
                      </Accordion.Toggle>
                      <Accordion.Collapse
                        eventKey="1"
                        className={"slowAcordeon"}>
                        <Card.Body>
                          <MiDataTableServer
                            estadoForm={""}
                            formulario={{ id: 0 }}
                            id={"manlogv2pend"}
                            columnas={
                              cookies.get("nivel") > "3"
                                ? confPantalla.manlogv2.controles
                                  .datatablemantenimientospendientes
                                  .columnstrabajador
                                : confPantalla.manlogv2.controles
                                  .datatablemantenimientospendientes.columns
                            }
                            data={mantenimientosPendientes}
                            buttons={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.buttons
                            }
                            ordering={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.ordering
                            }
                            order={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.order
                            }
                            searching={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.searching
                            }
                            paging={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.paging
                            }
                            select={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.select
                            }
                            pagelength={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.pagelength
                            }
                            columnactions={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.columnactions
                                .title
                            }
                            linkColumns={
                              confPantalla.manlogv2.controles
                                .datatablemantenimientospendientes.linkColumns
                            }
                            traduction={
                              confPantalla.config.trad.components.datatable
                            }
                            functionClickTd={showMensaje}
                            clickBtnDataTableButtons={
                              handleMantenimientosPendientesFilter
                            }
                            goToEquiposL={goToEquiposL}
                            onSearchChange={handleDataTableSearchMantenimientos}
                            onSortChange={onSortChangePendientes}
                            onPageLengthChange={
                              handlePageLengthChangeMantenimientos
                            }
                            paginationInfo={paginationInfoMantenimientos}
                            searchBackend={true}
                            loadingTable={loadingTableMantenimientos}
                            saveLoadingTable={saveLoadingTable}
                            showNativeInfo={false}
                            showNativePaging={false}
                            showNativeLengthMenu={false}
                          />

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div
                              className="dataTables_info"
                              style={{ paddingRight: "15px" }}>
                              {paginationInfoMantenimientos}
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers">
                              <ul
                                className="pagination"
                                style={{ marginBottom: 0 }}>
                                <li
                                  className={`paginate_button page-item previous ${currentPagePendientes === 1 || loadingTableMantenimientos ? "disabled" : ""}`}
                                  id="manlogv2pend_previous">
                                  <a
                                    href="#"
                                    aria-controls="manlogv2pend"
                                    role="link"
                                    data-dt-idx="previous"
                                    tabIndex="-1"
                                    className="page-link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        currentPagePendientes > 1 &&
                                        !loadingTableMantenimientos
                                      )
                                        handlePreviousPageMantenimientos();
                                    }}>
                                    &lt;
                                  </a>
                                </li>
                                {getPaginationItemsMantenimientos().map(
                                  (item, index) => {
                                    if (item === "...") {
                                      return (
                                        <li
                                          key={index}
                                          className="paginate_button page-item disabled">
                                          <span className="page-link">...</span>
                                        </li>
                                      );
                                    }
                                    return (
                                      <li
                                        key={index}
                                        className={`paginate_button page-item ${item === currentPagePendientes ? "active" : ""}`}>
                                        <a
                                          href="#"
                                          aria-controls="manlogv2pend"
                                          role="link"
                                          className="page-link"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            handlePageChangeMantenimientos(
                                              item,
                                            );
                                          }}>
                                          {item}
                                        </a>
                                      </li>
                                    );
                                  },
                                )}
                                <li
                                  className={`paginate_button page-item next ${currentPagePendientes === totalPagesMantenimientos || loadingTableMantenimientos ? "disabled" : ""}`}
                                  id="manlogv2pend_next">
                                  <a
                                    href="#"
                                    aria-controls="manlogv2pend"
                                    role="link"
                                    data-dt-idx="next"
                                    tabIndex="0"
                                    className="page-link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        currentPagePendientes <
                                        totalPagesMantenimientos &&
                                        !loadingTableMantenimientos
                                      )
                                        handleNextPageMantenimientos();
                                    }}>
                                    &gt;
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>

                          {cookies.get("nivel") <= "3" ? (
                            <Fragment>
                              <MiDataTableServer
                                estadoForm={""}
                                formulario={{ id: 0 }}
                                id={"manlogv2pendientesdeasignar"}
                                columnas={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.columns
                                }
                                data={pendientesAsignar}
                                linkColumns={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.linkColumns
                                }
                                buttons={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.buttons
                                }
                                ordering={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.ordering
                                }
                                order={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.order
                                }
                                searching={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.searching
                                }
                                paging={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.paging
                                }
                                select={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.select
                                }
                                pagelength={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.pagelength
                                }
                                columnactions={
                                  confPantalla.manlogv2.controles
                                    .datatablependientesdeasignar.columnactions
                                    .title
                                }
                                traduction={
                                  confPantalla.config.trad.components.datatable
                                }
                                functionClickTd={setMantenimientoToForm}
                                goToEquiposL={goToEquiposL}
                                columnGoToEquiposL={5}
                                onSearchChange={handleDataTableSearchAsignar}
                                onSortChange={onSortChangeAsignar}
                                onPageLengthChange={
                                  handlePageLengthChangeAsignar
                                }
                                paginationInfo={paginationInfoAsignar}
                                searchBackend={true}
                                loadingTable={loadingTableAsignar}
                                saveLoadingTable={saveLoadingTable}
                                showNativeInfo={false}
                                showNativePaging={false}
                                showNativeLengthMenu={false}
                              />

                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <div
                                  className="dataTables_info"
                                  style={{ paddingRight: "15px" }}>
                                  {paginationInfoAsignar}
                                </div>
                                <div className="dataTables_paginate paging_simple_numbers">
                                  <ul
                                    className="pagination"
                                    style={{ marginBottom: 0 }}>
                                    <li
                                      className={`paginate_button page-item previous ${currentPageAsignar === 1 || loadingTableAsignar ? "disabled" : ""}`}
                                      id="manlogv2pendientesdeasignar_previous">
                                      <a
                                        href="#"
                                        aria-controls="manlogv2pendientesdeasignar"
                                        role="link"
                                        data-dt-idx="previous"
                                        tabIndex="-1"
                                        className="page-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (
                                            currentPageAsignar > 1 &&
                                            !loadingTableAsignar
                                          )
                                            handlePreviousPageAsignar();
                                        }}>
                                        &lt;
                                      </a>
                                    </li>
                                    {getPaginationItemsAsignar().map(
                                      (item, index) => {
                                        if (item === "...") {
                                          return (
                                            <li
                                              key={index}
                                              className="paginate_button page-item disabled">
                                              <span className="page-link">
                                                ...
                                              </span>
                                            </li>
                                          );
                                        }
                                        return (
                                          <li
                                            key={index}
                                            className={`paginate_button page-item ${item === currentPageAsignar ? "active" : ""}`}>
                                            <a
                                              href="#"
                                              aria-controls="manlogv2pendientesdeasignar"
                                              role="link"
                                              className="page-link"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                handlePageChangeAsignar(item);
                                              }}>
                                              {item}
                                            </a>
                                          </li>
                                        );
                                      },
                                    )}
                                    <li
                                      className={`paginate_button page-item next ${currentPageAsignar === totalPagesAsignar || loadingTableAsignar ? "disabled" : ""}`}
                                      id="manlogv2pendientesdeasignar_next">
                                      <a
                                        href="#"
                                        aria-controls="manlogv2pendientesdeasignar"
                                        role="link"
                                        data-dt-idx="next"
                                        tabIndex="0"
                                        className="page-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          if (
                                            currentPageAsignar <
                                            totalPagesAsignar &&
                                            !loadingTableAsignar
                                          )
                                            handleNextPageAsignar();
                                        }}>
                                        &gt;
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </Fragment>
                          ) : null}
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                    <Card>
                      <Accordion.Toggle
                        as={Card.Header}
                        eventKey="2"
                        onClick={() => toogleAcordeon("2")}
                        className={acordeonPrin == "2" ? "activeAcordeon" : ""}>
                        <i
                          className={
                            confPantalla.manlogv2.historicos.icono
                          }></i>{" "}
                        {confPantalla.manlogv2.historicos.titulo}
                        {acordeonPrin == "2" ? (
                          <i
                            className={
                              "fal fa-chevron-up float-right fa-2x"
                            }></i>
                        ) : (
                          <i
                            className={
                              "fal fa-chevron-down float-right fa-2x"
                            }></i>
                        )}
                      </Accordion.Toggle>
                      <Accordion.Collapse
                        eventKey="2"
                        className={"slowAcordeon"}>
                        <Card.Body>
                          <MiDataTableServer
                            estadoForm={""}
                            formulario={{ id: 0 }}
                            id={"manlogv2his"}
                            columnas={[
                              { title: "Equipo", data: "equipo" },
                              { title: "Descripción", data: "descripcion" },
                              { title: "Última Ejec.", data: "fecult" },
                              { title: "Próxima Ejec.", data: "fecpro" },
                              { title: "Doc. Mantenimientos", data: "numadj" },
                              { title: "Doc. Equipos", data: "numadjequi" },
                              { title: "Equipo", data: "idequ" },
                            ]}
                            data={historicos}
                            buttons={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.buttons
                            }
                            ordering={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.ordering
                            }
                            order={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.order
                            }
                            searching={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.searching
                            }
                            paging={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.paging
                            }
                            select={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.select
                            }
                            pagelength={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.pagelength
                            }
                            columnactions={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.columnactions.title
                            }
                            linkColumns={
                              confPantalla.manlogv2.controles
                                .datatablehistoricos.linkColumns
                            }
                            traduction={
                              confPantalla.config.trad.components.datatable
                            }
                            functionClickTd={showEditarLinea}
                            goToEquiposL={goToEquiposL}
                            onSearchChange={handleDataTableSearch}
                            onSortChange={onSortChangeHistoricos}
                            onPageLengthChange={handlePageLengthChange}
                            paginationInfo={paginationInfo}
                            searchBackend={true}
                            loadingTable={loadingTable}
                            saveLoadingTable={saveLoadingTable}
                            showNativeInfo={false}
                            showNativePaging={false}
                            showNativeLengthMenu={false}
                          />

                          <div className="d-flex justify-content-between align-items-center mt-3">
                            <div
                              className="dataTables_info"
                              style={{ paddingRight: "15px" }}>
                              {paginationInfo}
                            </div>
                            <div className="dataTables_paginate paging_simple_numbers">
                              <ul
                                className="pagination"
                                style={{ marginBottom: 0 }}>
                                <li
                                  className={`paginate_button page-item previous ${currentPage === 1 || loadingTable ? "disabled" : ""}`}
                                  id="manlogv2his_previous">
                                  <a
                                    href="#"
                                    aria-controls="manlogv2his"
                                    role="link"
                                    data-dt-idx="previous"
                                    tabIndex="-1"
                                    className="page-link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (currentPage > 1 && !loadingTable)
                                        handlePreviousPage();
                                    }}>
                                    &lt;
                                  </a>
                                </li>
                                {getPaginationItems().map((item, index) => {
                                  if (item === "...") {
                                    return (
                                      <li
                                        key={index}
                                        className="paginate_button page-item disabled">
                                        <span className="page-link">...</span>
                                      </li>
                                    );
                                  }

                                  return (
                                    <li
                                      key={index}
                                      className={`paginate_button page-item ${item === currentPage ? "active" : ""}`}>
                                      <a
                                        href="#"
                                        aria-controls="manlogv2his"
                                        role="link"
                                        className="page-link"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handlePageChange(item);
                                        }}>
                                        {item}
                                      </a>
                                    </li>
                                  );
                                })}
                                <li
                                  className={`paginate_button page-item next ${currentPage === totalPages || loadingTable ? "disabled" : ""}`}
                                  id="manlogv2his_next">
                                  <a
                                    href="#"
                                    aria-controls="manlogv2his"
                                    role="link"
                                    data-dt-idx="next"
                                    tabIndex="0"
                                    className="page-link"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (
                                        currentPage < totalPages &&
                                        !loadingTable
                                      )
                                        handleNextPage();
                                    }}>
                                    &gt;
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </Section>
              ) : (
                <LoadingPage />
              )}
            </Fragment>
          )}
          {showModal == true ? (
            <Modal
              show={showModal}
              onHide={() => saveShowModal(false)}
              aria-labelledby="example-custom-modal-styling-title"
              centered={true}
              dialogClassName="modal-90w">
              {/* <Modal.Header closeButton> */}
              <Modal.Header>
                <div
                  className="col-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  {/* <h4>{confPantalla.manlogv2.modal.header.title}</h4>  */}
                  <h4>{txtHeaderModal}</h4>
                  {recurrencia != "" ? (
                    <span
                      className="alert-primary pl-3 pr-3 pt-2 pb-2 float-right"
                      style={{ borderRadius: "5px" }}>
                      {recurrencia}
                    </span>
                  ) : null}
                </div>
              </Modal.Header>
              <Modal.Body>
                <FormRow>
                  {
                    <MiSelect
                      estadoForm={""}
                      val={selectIdEquipoModal}
                      loading={loading ? true : false}
                      id={confPantalla.manlogv2.controles.idequ.id}
                      name={confPantalla.manlogv2.controles.idequ.name}
                      label={confPantalla.manlogv2.controles.idequ.label}
                      placeholder={
                        confPantalla.manlogv2.controles.idequ.placeholder
                      }
                      col={12}
                      isClearable={
                        confPantalla.manlogv2.controles.idequ.isclearable
                      }
                      isSearchable={
                        confPantalla.manlogv2.controles.idequ.issearchable
                      }
                      dataType={confPantalla.manlogv2.controles.idequ.datatype}
                      data={confPantalla.manlogv2.controles.idequ.data}
                      required={confPantalla.manlogv2.controles.idequ.required}
                      disabled={confPantalla.manlogv2.controles.idequ.disabled}
                      readOnly={confPantalla.manlogv2.controles.idequ.readonly}
                      disablethisid={
                        confPantalla.manlogv2.controles.idequ.disablethisid
                      }
                      disableids={
                        confPantalla.manlogv2.controles.idequ.disableids
                      }
                      formulario={{ id: 0 }}
                      change={(selectedItem, nameOfComponent) =>
                        handleSelect(
                          selectedItem,
                          nameOfComponent,
                          saveSelectIdEquipoModal,
                          true,
                        )
                      }
                      saveBackUpOptions={saveBackUpOptionsSelectEquipo}
                    />
                  }
                </FormRow>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}>
                  {selectIdEquipoModal == 0 ? (
                    <div
                      className="alert alert-danger text-center mr-1"
                      role="alert">
                      {confPantalla.manlogv2.modal.txterrorman.title}
                    </div>
                  ) : null}
                  {equipoAsociadoMant == 0 && accionModal == "editar" ? (
                    <div
                      className="alert alert-danger text-center mr-1"
                      role="alert">
                      {confPantalla.manlogv2.modal.txterrorequipo.title}
                    </div>
                  ) : null}
                </div>
                <FormRow>
                  <FormInput
                    estadoForm={""}
                    value={inputModalFecUlt}
                    loading={loading ? true : false}
                    id={confPantalla.manlogv2.modal.fecult.id}
                    type={confPantalla.manlogv2.modal.fecult.type}
                    name={confPantalla.manlogv2.modal.fecult.name}
                    label={confPantalla.manlogv2.modal.fecult.label}
                    placeholder={confPantalla.manlogv2.modal.fecult.placeholder}
                    col={confPantalla.manlogv2.modal.fecult.col}
                    required={confPantalla.manlogv2.modal.fecult.required}
                    readonly={
                      cookies.get("nivel") == 4 && accionModal == "editar"
                        ? "readonly"
                        : ""
                    }
                    disabled={confPantalla.manlogv2.modal.fecult.disabled}
                    change={(e) => handleInputFecUltEje(e)}
                    // change=     { e => handleInput(e, saveInputModalFecUlt) }
                    onBlur={null}
                  />
                  <FormInput
                    estadoForm={""}
                    value={inputModalHoras}
                    loading={loading ? true : false}
                    id={confPantalla.manlogv2.modal.horas.id}
                    type={confPantalla.manlogv2.modal.horas.type}
                    name={confPantalla.manlogv2.modal.horas.name}
                    label={confPantalla.manlogv2.modal.horas.label}
                    placeholder={confPantalla.manlogv2.modal.horas.placeholder}
                    col={confPantalla.manlogv2.modal.horas.col}
                    required={
                      cookies.get("nivel") == 4 && accionModal == "editar"
                        ? "readonly"
                        : ""
                    }
                    readonly={confPantalla.manlogv2.modal.horas.readonly}
                    disabled={confPantalla.manlogv2.modal.horas.disabled}
                    change={(e) => handleInput(e, saveInputModalHoras)}
                    onBlur={null}
                  />
                  {/* {
                                selectIdEquipoModal > 0 && equipoAsociadoMant > 0
                                ? */}
                  <FormInput
                    estadoForm={""}
                    value={inputModalHActuales}
                    loading={loading ? true : false}
                    id={confPantalla.manlogv2.modal.hactuales.id}
                    type={confPantalla.manlogv2.modal.hactuales.type}
                    name={confPantalla.manlogv2.modal.hactuales.name}
                    label={confPantalla.manlogv2.modal.hactuales.label}
                    placeholder={
                      confPantalla.manlogv2.modal.hactuales.placeholder
                    }
                    col={confPantalla.manlogv2.modal.hactuales.col}
                    required={confPantalla.manlogv2.modal.hactuales.required}
                    readonly={confPantalla.manlogv2.modal.hactuales.readonly}
                    disabled={confPantalla.manlogv2.modal.hactuales.disabled}
                    change={(e) => handleInput(e, saveInputModalHActuales)}
                    onBlur={null}
                  />
                  {/* :
                                    null
                                } */}
                  {selectIdEquipoModal > 0 && tipoRecurrenciaDocModal > 0 ? (
                    <Fragment>
                      <FormInput
                        estadoForm={""}
                        value={inputModalFecPro}
                        loading={loading || loadingFecPro ? true : false}
                        id={confPantalla.manlogv2.modal.fecpro.id}
                        type={confPantalla.manlogv2.modal.fecpro.type}
                        name={confPantalla.manlogv2.modal.fecpro.name}
                        label={confPantalla.manlogv2.modal.fecpro.label}
                        placeholder={
                          confPantalla.manlogv2.modal.fecpro.placeholder
                        }
                        col={confPantalla.manlogv2.modal.fecpro.col}
                        required={confPantalla.manlogv2.modal.fecpro.required}
                        readonly={confPantalla.manlogv2.modal.fecpro.readonly}
                        disabled={confPantalla.manlogv2.modal.fecpro.disabled}
                        change={(e) => handleInput(e, saveInputModalFecPro)}
                        onBlur={null}
                      />
                      {accionModal == "editar" ? (
                        <CheckIos
                          val={checkModalAvisar}
                          name={null}
                          label={confPantalla.manlogv2.modal.avisar.title}
                          id={"checkavisar"}
                          col={"3"}
                          change={(e) => handleCheck(e, saveCheckModalAvisar)}
                          required={false}
                          disabled={false}
                        />
                      ) : (
                        <div className="form-group">
                          <button
                            className="btn btn-outline-warning "
                            style={{ marginTop: "32px" }}
                            onClick={(e) => setAviso(e)}
                            disabled={
                              loading == true || inputModalFecPro == ""
                                ? true
                                : false
                            }>
                            <i className="fal fa-calendar-alt mr-1"></i>
                            {confPantalla.manlogv2.modal.btnavisar.title}
                          </button>
                        </div>
                      )}
                    </Fragment>
                  ) : null}
                </FormRow>
                <UplmPlusBtn
                  idReg={accionModal == "editar" ? lineaEditar.id : 0}
                  id={confPantalla.manlogv2.modal.uplmplusbtn.id}
                  getAdj={confPantalla.manlogv2.modal.uplmplusbtn.getadj}
                  saveAdj={confPantalla.manlogv2.modal.uplmplusbtn.saveadj}
                  estadoForm={
                    cookies.get("nivel") == 4 && accionModal == "editar"
                      ? "readonly"
                      : ""
                  }
                  col={12}
                  readonly={confPantalla.manlogv2.modal.uplmplusbtn.readonly}
                  traduction={confPantalla.config.trad.components}
                  datatable={confPantalla.manlogv2.modal.uplmplusbtn.datatable}
                  select={confPantalla.manlogv2.modal.uplmplusbtn.select}
                  noBtn={true}
                  noModal={true}
                  saveAdjuntosParam={saveAdjuntos}
                />
                <p className="font-italic text-center">
                  {confPantalla.manlogv2.txtrequired.title}
                </p>
                {loading ? (
                  <div
                    style={{
                      height: 50,
                      marginTop: 5,
                      marginBottom: 10,
                      textAlign: "center",
                    }}>
                    <Spinner animation="border" />
                  </div>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <div className="text-right">
                  {selectIdEquipoModal > 0 &&
                    totLin > 0 &&
                    cookies.get("nivel") < "4" ? (
                    // <div className='text-right col-md-2'>
                    <button
                      className="btn btn-success  mt-1 mr-1"
                      style={{ marginTop: "32px" }}
                      onClick={(e) => ejecutar(e)}
                      disabled={loading == true ? true : false}>
                      Aceptar
                    </button>
                  ) : // </div>
                    (selectIdEquipoModal > 0 &&
                      totLin > 0 &&
                      cookies.get("nivel") == "4" &&
                      accionModal == "crear") ? (
                    // <div className='text-right col-md-2'>
                    <button
                      className="btn btn-success  mt-1 mr-1"
                      style={{ marginTop: "32px" }}
                      onClick={(e) => ejecutar(e)}
                      disabled={loading == true ? true : false}>
                      Aceptar
                    </button>
                  ) : // </div>
                  totLin == 0 && accionModal == "editar" ? (
                    <button
                      className="btn btn-success  mt-1 mr-1"
                      style={{ marginTop: "32px" }}
                      onClick={(e) => accionEditar(e, false)}
                      disabled={loading == true ? true : false}>
                      Aceptar
                    </button>
                  ) : totLin == 0 && accionModal == "crear" ? (
                    <button
                      className="btn btn-success  mt-1 mr-1"
                      style={{ marginTop: "32px" }}
                      onClick={(e) => accionCrear(e, false)}
                      disabled={loading == true ? true : false}>
                      Aceptar
                    </button>
                  ) : null}
                  <button
                    className="btn btn-danger mt-1"
                    onClick={() => saveShowModal(false)}
                    disabled={loading == true ? true : false}>
                    {confPantalla.manlogv2.modal.btncancelar.title}
                  </button>
                </div>
              </Modal.Footer>
            </Modal>
          ) : null}
          {showModalMensaje == true ? (
            <Modal
              show={showModalMensaje}
              onHide={() => saveShowModalMensaje(false)}
              aria-labelledby="example-custom-modal-styling-title"
              centered={true}
              dialogClassName="modal-90w">
              {/* <Modal.Header closeButton> */}
              <Modal.Header>
                <div
                  className="col-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}>
                  <h4>{confPantalla.manlogv2.modalmensaje.header.title}</h4>
                </div>
              </Modal.Header>
              <Modal.Body>
                <FormRow>
                  <MiSelect
                    estadoForm={""}
                    val={mensajeEstado}
                    loading={loadReg ? true : false}
                    id={confPantalla.manlogv2.modalmensaje.msg_idest.id}
                    name={confPantalla.manlogv2.modalmensaje.msg_idest.name}
                    label={confPantalla.manlogv2.modalmensaje.msg_idest.label}
                    placeholder={
                      confPantalla.manlogv2.modalmensaje.msg_idest.placeholder
                    }
                    col={confPantalla.manlogv2.modalmensaje.msg_idest.col}
                    isClearable={
                      confPantalla.manlogv2.modalmensaje.msg_idest.isclearable
                    }
                    isSearchable={
                      confPantalla.manlogv2.modalmensaje.msg_idest.issearchable
                    }
                    dataType={
                      confPantalla.manlogv2.modalmensaje.msg_idest.datatype
                    }
                    data={confPantalla.manlogv2.modalmensaje.msg_idest.data}
                    required={
                      confPantalla.manlogv2.modalmensaje.msg_idest.required
                    }
                    disabled={
                      confPantalla.manlogv2.modalmensaje.msg_idest.disabled
                    }
                    readOnly={
                      confPantalla.manlogv2.modalmensaje.msg_idest.readonly
                    }
                    disablethisid={
                      confPantalla.manlogv2.modalmensaje.msg_idest.disablethisid
                    }
                    disableids={
                      confPantalla.manlogv2.modalmensaje.msg_idest.disableids
                    }
                    formulario={{ id: 0 }}
                    change={(selectedItem, nameOfComponent) =>
                      handleSelect(
                        selectedItem,
                        nameOfComponent,
                        saveMensajeEstado,
                      )
                    }
                  />
                  <FormInput
                    estadoForm={""}
                    value={mensajeRecordatorio}
                    loading={loadReg ? true : false}
                    id={confPantalla.manlogv2.modalmensaje.rem_date.id}
                    type={confPantalla.manlogv2.modalmensaje.rem_date.type}
                    name={confPantalla.manlogv2.modalmensaje.rem_date.name}
                    label={confPantalla.manlogv2.modalmensaje.rem_date.label}
                    placeholder={
                      confPantalla.manlogv2.modalmensaje.rem_date.placeholder
                    }
                    col={confPantalla.manlogv2.modalmensaje.rem_date.col}
                    required={
                      confPantalla.manlogv2.modalmensaje.rem_date.required
                    }
                    readonly={
                      confPantalla.manlogv2.modalmensaje.rem_date.readonly
                    }
                    disabled={
                      confPantalla.manlogv2.modalmensaje.rem_date.disabled
                    }
                    change={(e) => handleInput(e, saveMensajeRecordatorio)}
                    onBlur={null}
                  />
                  <FormInput
                    estadoForm={""}
                    value={mensajeLimite}
                    loading={loadReg ? true : false}
                    id={confPantalla.manlogv2.modalmensaje.exp_date.id}
                    type={confPantalla.manlogv2.modalmensaje.exp_date.type}
                    name={confPantalla.manlogv2.modalmensaje.exp_date.name}
                    label={confPantalla.manlogv2.modalmensaje.exp_date.label}
                    placeholder={
                      confPantalla.manlogv2.modalmensaje.exp_date.placeholder
                    }
                    col={confPantalla.manlogv2.modalmensaje.exp_date.col}
                    required={
                      confPantalla.manlogv2.modalmensaje.exp_date.required
                    }
                    readonly={
                      cookies.get("nivel") > "3"
                        ? "readonly"
                        : confPantalla.manlogv2.modalmensaje.exp_date.readonly
                    }
                    disabled={
                      cookies.get("nivel") > "3"
                        ? "disabled"
                        : confPantalla.manlogv2.modalmensaje.exp_date.disabled
                    }
                    change={(e) => handleInput(e, saveMensajeLimite)}
                    onBlur={null}
                  />
                </FormRow>
                <FormRow clases="">
                  <MiSelect
                    estadoForm={""}
                    val={mensajePara}
                    loading={loadReg ? true : false}
                    id={confPantalla.manlogv2.modalmensaje.to_idage.id}
                    name={confPantalla.manlogv2.modalmensaje.to_idage.name}
                    label={confPantalla.manlogv2.modalmensaje.to_idage.label}
                    placeholder={
                      confPantalla.manlogv2.modalmensaje.to_idage.placeholder
                    }
                    col={confPantalla.manlogv2.modalmensaje.to_idage.col}
                    isClearable={
                      confPantalla.manlogv2.modalmensaje.to_idage.isclearable
                    }
                    isSearchable={
                      confPantalla.manlogv2.modalmensaje.to_idage.issearchable
                    }
                    dataType={
                      confPantalla.manlogv2.modalmensaje.to_idage.datatype
                    }
                    data={confPantalla.manlogv2.modalmensaje.to_idage.data}
                    required={
                      confPantalla.manlogv2.modalmensaje.to_idage.required
                    }
                    disabled={
                      cookies.get("nivel") > "3"
                        ? "disabled"
                        : confPantalla.manlogv2.modalmensaje.to_idage.disabled
                    }
                    readOnly={
                      cookies.get("nivel") > "3"
                        ? "readonly"
                        : confPantalla.manlogv2.modalmensaje.to_idage.readonly
                    }
                    disablethisid={
                      confPantalla.manlogv2.modalmensaje.to_idage.disablethisid
                    }
                    disableids={
                      confPantalla.manlogv2.modalmensaje.to_idage.disableids
                    }
                    formulario={{ id: 0 }}
                    change={(selectedItem, nameOfComponent) =>
                      handleSelect(
                        selectedItem,
                        nameOfComponent,
                        saveMensajePara,
                      )
                    }
                  />
                </FormRow>
                <FormRow>
                  <TextArea
                    estadoForm={""}
                    value={mensajeMsg}
                    loading={loadReg ? true : false}
                    id={confPantalla.manlogv2.modalmensaje.msg_sub.id}
                    name={confPantalla.manlogv2.modalmensaje.msg_sub.name}
                    rows={confPantalla.manlogv2.modalmensaje.msg_sub.rows}
                    label={confPantalla.manlogv2.modalmensaje.msg_sub.label}
                    placeholder={
                      confPantalla.manlogv2.modalmensaje.msg_sub.placeholder
                    }
                    col={confPantalla.manlogv2.modalmensaje.msg_sub.col}
                    required={
                      confPantalla.manlogv2.modalmensaje.msg_sub.required
                    }
                    readonly={
                      confPantalla.manlogv2.modalmensaje.msg_sub.readonly
                    }
                    disabled={
                      confPantalla.manlogv2.modalmensaje.msg_sub.disabled
                    }
                    change={(e) => handleInput(e, saveMensajeMsg)}
                    onBlur={null}
                  />
                </FormRow>
                {loading ? (
                  <div
                    style={{
                      height: 50,
                      marginTop: 5,
                      marginBottom: 10,
                      textAlign: "center",
                    }}>
                    <Spinner animation="border" />
                  </div>
                ) : null}
              </Modal.Body>
              <Modal.Footer>
                <div className="text-right">
                  <button
                    className="btn btn-success mt-1 mr-1"
                    style={{ marginTop: "32px" }}
                    onClick={(e) => accionMensaje(e)}
                    disabled={loading == true ? true : false}>
                    {confPantalla.manlogv2.modalmensaje.btnaceptar.title}
                  </button>
                  <button
                    className="btn btn-danger mt-1"
                    onClick={() => saveShowModalMensaje(false)}
                    disabled={loading == true ? true : false}>
                    {confPantalla.manlogv2.modalmensaje.btncancelar.title}
                  </button>
                </div>
              </Modal.Footer>
            </Modal>
          ) : null}
        </section>
      </div>
      <Footer />
    </div>
  );
}
export default Manlogv2V2;
